import { isNotDefined } from '@sgme/fp';

import type { PxCoordinates } from '@/types/grid.ts';
import { ZINDEX_TILE, ZINDEX_TILE__DRAGGED, ZINDEX_TILESKELETON } from '@/utils/grid/zIndices.ts';

// avoiding zIndex chaos from outside, when no tile is zoomed
const ALLOWED_ZINDEXES = [ZINDEX_TILESKELETON, ZINDEX_TILE, ZINDEX_TILE__DRAGGED] as const;

type Parameters = {
  element: Element | null | undefined;
  position: PxCoordinates;
  zIndex: (typeof ALLOWED_ZINDEXES)[number];
};

export function updateElementAbsolutePosition({ element, position: { x, y }, zIndex }: Parameters) {
  if (isNotDefined(element) || !(element instanceof HTMLElement)) {
    console.error('Cannot update element absolute position: element is not defined or not an HTMLElement');
    return;
  }

  element.style.display = 'block';
  element.style.left = `${x}px`;
  element.style.top = `${y}px`;
  element.style.zIndex = zIndex;
}
